var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M23.351.648a2.188 2.188 0 0 0-2.31-.515l-.216.077A32.72 32.72 0 0 0 7.964 8.035a22.71 22.71 0 0 0-2.471 3.016c-1.4 2-1.666 4.19.054 5.91l.039.038-2.293 2.293a1 1 0 0 0 1.414 1.414L7 18.413l.038.04c1.721 1.72 3.915 1.451 5.91.053a22.694 22.694 0 0 0 3.016-2.47 32.72 32.72 0 0 0 7.825-12.863l.077-.216a2.185 2.185 0 0 0-.515-2.309ZM11 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm3-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM2.363 13.037A2.36 2.36 0 0 1 0 10.675a2.41 2.41 0 0 1 .665-1.654 9.776 9.776 0 0 1 6.46-2.944c-.191.182-.386.355-.575.544A24.8 24.8 0 0 0 3.855 9.9a8.2 8.2 0 0 0-1.38 3.133l-.112.005ZM11 21.524a8.185 8.185 0 0 0 3.133-1.38 24.729 24.729 0 0 0 3.283-2.695c.19-.189.362-.384.545-.575a9.782 9.782 0 0 1-2.945 6.46 2.41 2.41 0 0 1-1.653.665A2.363 2.363 0 0 1 11 21.636v-.112Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrRocket);
export default __webpack_public_path__ + "static/media/fi-sr-rocket.79b486ed256bb423900a1f527e78ac11.svg";
export { ForwardRef as ReactComponent };